import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import HomePage from './pages/HomePage';
import ToursPage from './pages/ToursPage';
import IstanbulToursPage from './pages/IstanbulToursPage';
import YurticiToursPage from './pages/YurticiToursPage';
import YurtdisiToursPage from './pages/YurtdisiToursPage';
import TourDetailPage from './pages/TourDetailPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import Layout from './components/Layout';
import { Toaster } from '@/components/ui/sonner';
import { AnalyticsTracker } from './components/AnalyticsTracker';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            {/* Admin routes without layout */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            {/* Public routes with layout */}
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/turlar" element={<Layout><ToursPage /></Layout>} />
            <Route path="/turlar/istanbul" element={<Layout><IstanbulToursPage /></Layout>} />
            <Route path="/turlar/yurtici" element={<Layout><YurticiToursPage /></Layout>} />
            <Route path="/turlar/yurtdisi" element={<Layout><YurtdisiToursPage /></Layout>} />
            <Route path="/turlar/:slug" element={<Layout><TourDetailPage /></Layout>} />
            <Route path="/istanbul-hikayeleri" element={<Layout><BlogPage /></Layout>} />
            <Route path="/istanbul-hikayeleri/:slug" element={<Layout><BlogDetailPage /></Layout>} />
            <Route path="/hakkimizda" element={<Layout><AboutPage /></Layout>} />
            <Route path="/iletisim" element={<Layout><ContactPage /></Layout>} />
            <Route path="/admin" element={<Layout><AdminDashboardPage /></Layout>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
